// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { createRoot } from 'react-dom/client';

import { applyTheme } from '@cloudscape-design/components/theming';

import { customTheme as theme } from '../../styles/theme';
import LineFlow from './app';

import '../../styles/base.scss';

const { reset } = applyTheme({ theme });
if (!reset) {
  /* empty */
}

createRoot(document.getElementById('app')!).render(<LineFlow />);
